import "../../utilities/globals/index.js";
export * from "./useApolloClient.js";
export * from "./useLazyQuery.js";
export * from "./useMutation.js";
export { useQuery } from "./useQuery.js";
export * from "./useSubscription.js";
export * from "./useReactiveVar.js";
export * from "./useFragment.js";
export { useSuspenseQuery } from "./useSuspenseQuery.js";
export { useBackgroundQuery } from "./useBackgroundQuery.js";
export { useSuspenseFragment } from "./useSuspenseFragment.js";
export { useLoadableQuery } from "./useLoadableQuery.js";
export { useQueryRefHandlers } from "./useQueryRefHandlers.js";
export { useReadQuery } from "./useReadQuery.js";
export { skipToken } from "./constants.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/react/hooks/index.js
// module id = 2141
// module chunks = 11